 /*local */ 
// export const apiUrl      = "http://localhost/connect/api/";
// export const baseUrl      = "http://localhost/connect";
// export const mediaUrl      = "http://localhost/connect/media/";
// export const sampleFileUrl      = "http://localhost/connect/media/sample_file/";
// export const cmscontentURL       = "http://localhost/connect/media/cmscontent";
// export const tapURL       = "http://localhost/connect/media/tabmanagement";
 //export const assetUrl       = "http://localhost:3000/assets/";



/*dev */

// export const apiUrl      = "https://dev-a.uxt.design/connect/api/";
// export const apiV1Url      = "https://dev-a.uxt.design/connect/v1/";
// export const baseUrl      = "https://dev-a.uxt.design/connect";
// export const mediaUrl      = "https://dev-a.uxt.design/connect/media/";
// export const sampleFileUrl      = "https://dev-a.uxt.design/connect/media/sample_file/";
// export const cmscontentURL       = "https://dev-a.uxt.design/connect/media/cmscontent"; 
// export const categoryURL       = "http://dev-a.uxt.design/connect/media/category";
// export const tapURL       = "http://dev-a.uxt.design/connect/media/tabmanagement";
// export const chatURL       = "https://dev-a.uxt.design/connect/media/smilesy";
// export const assetUrl       = "https://dev-a.uxt.design/connect/assets/";


// LIVE

export const apiUrl      = "https://admin.02.market/connect/api/";
export const apiV1Url      = "https://admin.02.market/connect/v1/";
export const baseUrl      = "https://admin.02.market/connect";
export const mediaUrl      = "https://admin.02.market/connect/media/";
export const sampleFileUrl      = "https://admin.02.market/connect/media/sample_file/";
export const cmscontentURL       = "https://admin.02.market/connect/media/cmscontent"; 
export const categoryURL       = "http://admin.02.market/connect/media/category";
export const tapURL       = "http://admin.02.market/connect/media/tabmanagement";
export const chatURL       = "http://admin.02.market/connect/media/smilesy";
export const assetUrl       = "https://admin.02.market/connect/assets/";

